<template>
  <div class="empty-layout">
    <Header />
    <!-- <Navigation v-if="isLoggedIn" /> -->
    <main id="content">
      <slot />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header/Header'
// import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import messages from '@/utils/messages'

export default {
  name: 'EmptyLayout',
  components: {
    Header,
    // Navigation,
    Footer
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    error() {
      return this.$store.getters.error
    }
  },
  watch: {
    error(error) {
      this.$error(`${messages[error.code]}` || 'Что-то пошло не так')
    }
  }
}
</script>
